// Check form content for bad words

// Regex for matching bad words:
var bannedWordsList = $.getJSON('/service/v1/banned-words');
var defamWordsList = $.getJSON('/service/v1/defamatory-words');

var textArea = $('#text');

if (textArea[0]) {
    console.log(textArea);

    textArea[0].insertAdjacentHTML('afterend', `
        <div class="review-errors-container">
            <div class="alert alert-danger review-text-error-swearing d-none" role="alert">
                ReviewSolicitors operates on a family friendly policy, please <strong>do not</strong> use swear words or you will not be able to submit your review.
            </div>
            <div class="alert alert-warning review-text-error d-none" role="alert">
                Please <strong>do not</strong> use defamatory language.
            </div>
            <div class="review-text-suggestions d-none">
                <div class="review-text-suggestions-inner"></div>
                <div class="review-text-suggestions__controls d-flex justify-content-center align-items-center">
                    <button type="button" class="btn btn-sm review-text-suggestions__btn review-text-suggestions__btn-prev">
                        <svg viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" class="review-text-suggestions__btn-icon review-text-suggestions__btn-icon--prev">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM28.7737 13.4466L25.9654 10.6883C25.5764 10.3062 24.953 10.3062 24.564 10.6883L12.2263 22.8066C11.8273 23.1985 11.8273 23.8415 12.2263 24.2334L23.5051 35.3117C23.8942 35.6938 24.5176 35.6938 24.9066 35.3117L27.7148 32.5534C28.1139 32.1615 28.1139 31.5185 27.7148 31.1266L20.6969 24.2334C20.2979 23.8415 20.2979 23.1985 20.6969 22.8066L28.7737 14.8734C29.1727 14.4815 29.1727 13.8385 28.7737 13.4466Z" fill="white"/>
                        </svg>                
                    </button>
                    <p class="text-center review-text-suggestions__counter">0/0</p>
                    <button type="button" class="btn btn-sm review-text-suggestions__btn review-text-suggestions__btn-next">
                        <svg viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" class="review-text-suggestions__btn-icon review-text-suggestions__btn-icon--next">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM14.7263 13.4466L17.5346 10.6883C17.9236 10.3062 18.547 10.3062 18.936 10.6883L31.2737 22.8066C31.6727 23.1985 31.6727 23.8415 31.2737 24.2334L19.9949 35.3117C19.6058 35.6938 18.9824 35.6938 18.5934 35.3117L15.7852 32.5534C15.3861 32.1615 15.3861 31.5185 15.7852 31.1266L22.8031 24.2334C23.2021 23.8415 23.2021 23.1985 22.8031 22.8066L14.7263 14.8734C14.3273 14.4815 14.3273 13.8385 14.7263 13.4466Z" fill="white"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    `);
}

var badWordsAmount = 0;
var badWords = new Set();
var bannedWords = new Set();
var errorMessage = $('.review-text-error');
var swearMessage = $('.review-text-error-swearing');
var suggestionsBox = $('.review-text-suggestions');
var prevSuggestionBtn = $('.review-text-suggestions__btn-prev');
var nextSuggestionBtn = $('.review-text-suggestions__btn-next');
var suggestionsCounter = $('.review-text-suggestions__counter');
var suggestionsInnerContainer = $('.review-text-suggestions-inner');
var currentSuggestion = 1;

var titleArea = $('#title');

if (titleArea[0]) {
    console.log(titleArea);

    titleArea[0].insertAdjacentHTML('afterend', `
        <div class="review-errors-container">
            <div class="alert alert-danger review-text-error-swearing-title d-none" role="alert">
                ReviewSolicitors operates on a family friendly policy, please <strong>do not</strong> use swear words or you will not be able to submit your review.
            </div>
            <div class="alert alert-warning review-text-error-title d-none" role="alert">
                Please <strong>do not</strong> use defamatory language.
            </div>
            <div class="review-text-suggestions-title d-none">
                <div class="review-text-suggestions-inner-title"></div>
                <div class="review-text-suggestions__controls d-flex justify-content-center align-items-center">
                    <button type="button" class="btn btn-sm review-text-suggestions__btn review-text-suggestions__btn-prev-title">
                        <svg viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" class="review-text-suggestions__btn-icon review-text-suggestions__btn-icon--prev">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM28.7737 13.4466L25.9654 10.6883C25.5764 10.3062 24.953 10.3062 24.564 10.6883L12.2263 22.8066C11.8273 23.1985 11.8273 23.8415 12.2263 24.2334L23.5051 35.3117C23.8942 35.6938 24.5176 35.6938 24.9066 35.3117L27.7148 32.5534C28.1139 32.1615 28.1139 31.5185 27.7148 31.1266L20.6969 24.2334C20.2979 23.8415 20.2979 23.1985 20.6969 22.8066L28.7737 14.8734C29.1727 14.4815 29.1727 13.8385 28.7737 13.4466Z" fill="white"/>
                        </svg>                
                    </button>
                    <p class="text-center review-text-suggestions__counter-title">0/0</p>
                    <button type="button" class="btn btn-sm review-text-suggestions__btn review-text-suggestions__btn-next-title">
                        <svg viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" class="review-text-suggestions__btn-icon review-text-suggestions__btn-icon--next">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM14.7263 13.4466L17.5346 10.6883C17.9236 10.3062 18.547 10.3062 18.936 10.6883L31.2737 22.8066C31.6727 23.1985 31.6727 23.8415 31.2737 24.2334L19.9949 35.3117C19.6058 35.6938 18.9824 35.6938 18.5934 35.3117L15.7852 32.5534C15.3861 32.1615 15.3861 31.5185 15.7852 31.1266L22.8031 24.2334C23.2021 23.8415 23.2021 23.1985 22.8031 22.8066L14.7263 14.8734C14.3273 14.4815 14.3273 13.8385 14.7263 13.4466Z" fill="white"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    `);
}
var badWordsAmountTitle = 0;
var badWordsTitle = new Set();
var bannedWordsTitle = new Set();
var errorMessageTitle = $('.review-text-error-title');
var swearMessageTitle = $('.review-text-error-swearing-title');
var suggestionsBoxTitle = $('.review-text-suggestions-title');
var prevSuggestionBtnTitle = $('.review-text-suggestions__btn-prev-title');
var nextSuggestionBtnTitle = $('.review-text-suggestions__btn-next-title');
var suggestionsCounterTitle = $('.review-text-suggestions__counter-title');
var suggestionsInnerContainerTitle = $('.review-text-suggestions-inner-title');
var currentSuggestionTitle = 1;

prevSuggestionBtnTitle.on('click', handlePrevTitle);
nextSuggestionBtnTitle.on('click', handleNextTitle);
prevSuggestionBtn.on('click', handlePrev);
nextSuggestionBtn.on('click', handleNext);

function updateCounterText() {  

    suggestionsCounter.text(currentSuggestion + '/' + badWords.size);

    suggestionsInnerContainer.children().each(function(index) {
        if (index === currentSuggestion - 1) {
            $(this).addClass('d-block');
        } else {
            $(this).removeClass('d-block');
        }
    });
}

function handlePrev() {
    if (currentSuggestion === 1) return;
    currentSuggestion--;
    updateCounterText();
}

function handleNext() {
    if (currentSuggestion === badWords.size) return;
    currentSuggestion++;
    updateCounterText();
}

function handlePrevTitle() {
    if (currentSuggestionTitle === 1) return;
    currentSuggestionTitle--;
    updateCounterTextTitle();
}

function handleNextTitle() {
    if (currentSuggestionTitle === badWordsTitle.size) return;
    currentSuggestionTitle++;
    updateCounterTextTitle();
}

function updateCounterTextTitle() {

    suggestionsCounterTitle.text(currentSuggestionTitle + '/' + badWordsTitle.size);

    suggestionsInnerContainerTitle.children().each(function(index) {
        if (index === currentSuggestionTitle - 1) {
            $(this).addClass('d-block');
        } else {
            $(this).removeClass('d-block');
        }
    });
}

function buildSuggestion(badWord, isShowing) {
    var suggestions = new Map(Object.entries(defamWordsList.responseJSON)).get(badWord);

    if (isShowing) {
        isShowing = ' d-block';
    } else {
        isShowing = '';
    }

    return '<div class="review-text-suggestions__suggestion d-none' + isShowing + ' data-key="' + badWord + '"><p>Instead of <strong>' + badWord + '</strong>, consider using one of the following:</p><ul class="review-text-suggestions__list"><li class="review-text-suggestions__list-item">"' + suggestions[0] + '"</li><li class="review-text-suggestions__list-item">"' + suggestions[1] + '"</li></ul></div>';
}

textArea.keyup(function() {
    textArea.focus();

    var words = textArea.val();
    var isSuggestionsBoxOpen = false;

    if (words !== null) {
        updateCounterText();
        //We need to split on any number of new lines, carriage returns, or spaces
        var splitRegex = /[\n\r\s.,_+:~();"']+/
        var wordsArray = words.split(splitRegex);
        var bannedStringArray = bannedWordsList.responseJSON.join().split(',');
        var defamStringArray = Object.keys(defamWordsList.responseJSON).join().split(',');

        // Test for matching defamatory words in wordsArray
        // If there's a match, add to badWords Set:
        wordsArray.forEach(function(word) {
            if (defamStringArray.includes(word.trim().toLowerCase())) {
                badWords.add(word.toLowerCase().replace(/[^\w\s]/, ''));
            }

            if (bannedStringArray.includes(word.trim().toLowerCase())) {
                bannedWords.add(word.toLowerCase().replace(/[^\w\s]/, ''));
            }
        });

        //Handle removing if the word no longer appears in text area
        badWords.forEach(function(word) {
            if (!wordsArray.includes(word)) {
                badWords.delete(word);
            }
        });

        bannedWords.forEach(function(word) {
            if (!wordsArray.includes(word)) {
                bannedWords.delete(word);
            }
        });

        if (badWords.size > 0) {
            var defamString2 = Object.keys(defamWordsList.responseJSON).join('|');
            var defamRegex = new RegExp('\\b(' + defamString2 + ')\\b', "gi");

            suggestionsInnerContainer.empty();
            errorMessage.addClass('d-block');
            // Highlight each defamatory word in the text area:
            textArea.highlightWithinTextarea({ highlight: defamRegex, className: 'bad-hightlight-color' });

            var currentBadWords = Array.from(badWords.values());

            currentBadWords.forEach(function(badWord, index) {
                var suggestionHtml;
                if (index === 0) {
                    suggestionHtml = buildSuggestion(badWord, true);
                } else {
                    suggestionHtml = buildSuggestion(badWord, false);
                }

                suggestionsInnerContainer.append(suggestionHtml);
            });
            
            // Show suggestions box:
            if (!isSuggestionsBoxOpen) {
                suggestionsBox.addClass('d-flex flex-column');
                suggestionsCounter.text(currentSuggestion + '/' + badWords.size);
            }
        }

        if (bannedWords.size > 0) {
            swearMessage.addClass('d-block');
            // Highlight each defamatory word in the text area:
            var bannedString2 = bannedWordsList.responseJSON.join('|');

            var mergedRegex = new RegExp('\\b(' + bannedString2 + ')\\b', "gi");

            textArea.highlightSwearWithinTextarea({ highlight: mergedRegex, className: 'hwt-hightlight-color' });
        }

        if (badWords.size === 0) {
            errorMessage.removeClass('d-block');
            suggestionsBox.removeClass('d-flex flex-column');
        }

        if (bannedWords.size === 0) {
            swearMessage.removeClass('d-block');
            $('.submit-review').attr('disabled', false);
            $('.submit-facebook').attr('disabled', false);
            $('.submit-linkedin').attr('disabled', false);
            $('.submit-google').attr('disabled', false);
        } else {
            $('.submit-review').attr('disabled', true);
            $('.submit-facebook').attr('disabled', true);
            $('.submit-linkedin').attr('disabled', true);
            $('.submit-google').attr('disabled', true);
        }
    }


    textArea.focus();
    
    if (badWords.size < currentSuggestion) {
        currentSuggestion = 1;
        updateCounterText();
    }
});

titleArea.keyup(function() {
    titleArea.focus();

    var words = titleArea.val();
    var isSuggestionsBoxOpen = false;

    if (words !== null) {
        updateCounterText();
        //We need to split on any number of new lines, carriage returns, or spaces
        var splitRegex = /[\n\r\s.,_+:~();"']+/
        var wordsArray = words.split(splitRegex);
        var bannedStringArray = bannedWordsList.responseJSON.join().split(',');
        var defamStringArray = Object.keys(defamWordsList.responseJSON).join().split(',');

        // Test for matching defamatory words in wordsArray
        // If there's a match, add to badWords Set:
        wordsArray.forEach(function(word) {
            if (defamStringArray.includes(word.trim().toLowerCase())) {
                badWordsTitle.add(word.toLowerCase().replace(/[^\w\s]/, ''));
            }

            if (bannedStringArray.includes(word.trim().toLowerCase())) {
                bannedWordsTitle.add(word.toLowerCase().replace(/[^\w\s]/, ''));
            }
        });

        //Handle removing if the word no longer appears in title
        badWordsTitle.forEach(function(word) {
            if (!wordsArray.includes(word)) {
                badWordsTitle.delete(word);
            }
        });

        bannedWordsTitle.forEach(function(word) {
            if (!wordsArray.includes(word)) {
                bannedWordsTitle.delete(word);
            }
        });

        if (badWordsTitle.size > 0) {
            var defamString2 = Object.keys(defamWordsList.responseJSON).join('|');
            var defamRegex = new RegExp('\\b(' + defamString2 + ')\\b', "gi");

            suggestionsInnerContainerTitle.empty();
            errorMessageTitle.addClass('d-block');
            // Highlight each defamatory word in the text area:
            titleArea.highlightWithinTextarea({ highlight: defamRegex, className: 'bad-hightlight-color' });

            var currentBadWords = Array.from(badWordsTitle.values());

            currentBadWords.forEach(function(badWord, index) {
                var suggestionHtml;
                if (index === 0) {
                    suggestionHtml = buildSuggestion(badWord, true);
                } else {
                    suggestionHtml = buildSuggestion(badWord, false);
                }

                suggestionsInnerContainerTitle.append(suggestionHtml);
            });

            // Show suggestions box:
            if (!isSuggestionsBoxOpen) {
                suggestionsBoxTitle.addClass('d-flex flex-column');
                suggestionsCounterTitle.text(currentSuggestionTitle + '/' + badWordsTitle.size);
            }
        }

        if (bannedWordsTitle.size > 0) {
            swearMessageTitle.addClass('d-block');
            // Highlight each defamatory word in the text area:
            var bannedString2 = bannedWordsList.responseJSON.join('|');

            var mergedRegex = new RegExp('\\b(' + bannedString2 + ')\\b', "gi");

            titleArea.highlightSwearWithinTextarea({ highlight: mergedRegex, className: 'hwt-hightlight-color' });
        }

        if (badWordsTitle.size === 0) {
            errorMessageTitle.removeClass('d-block');
            suggestionsBoxTitle.removeClass('d-flex flex-column');
        }

        if (bannedWordsTitle.size === 0) {
            swearMessageTitle.removeClass('d-block');
            $('.submit-review').attr('disabled', false);
            $('.submit-facebook').attr('disabled', false);
            $('.submit-linkedin').attr('disabled', false);
            $('.submit-google').attr('disabled', false);
        } else {
            $('.submit-review').attr('disabled', true);
            $('.submit-facebook').attr('disabled', true);
            $('.submit-linkedin').attr('disabled', true);
            $('.submit-google').attr('disabled', true);
        }
    }

    console.log('Title banned word count', bannedWordsTitle);

    titleArea.focus();

    if (badWordsTitle.size < currentSuggestionTitle) {
        currentSuggestionTitle = 1;
        updateCounterTextTitle();
    }
});

function getAuthenticated()
{

    const data = null;

    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;

    xhr.addEventListener("readystatechange", function () {
        if (this.readyState === this.DONE) {
            console.log(this.responseText);
        }
    });

    xhr.open("GET", "/service/v1/authentication");

    xhr.send(data);
}

setInterval(getAuthenticated,300000)